module.exports = __webpack_public_path__ + "static/media/flip.8ce813dc.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/audio/flip.mp3
// module id = 62
// module chunks = 0